/* eslint no-class-assign:off */
/* eslint no-console:off */
import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions';
import { getVisibleProjects, getIsProjectsFetching } from '../reducers';
import Loading from '../components/Loading';
import IndexList from '../components/indexFold/IndexList';
import langMap from '../langMap';

class Projects extends Component {
  constructor() {
    super();
    this.toggleIndex = this.toggleIndex.bind(this);
    this.onClickItem = this.onClickItem.bind(this);
    this.body = undefined;
  }
  componentDidMount() {
    this.fetchData();
    this.body = document.body;
  }
  componentDidUpdate(prevProps) {
    const { edition } = this.props;
    if (edition !== prevProps.edition) {
      this.fetchData();
    }
  }
  onClickItem() {
    if (window.outerWidth < 720) {
      this.body.classList.add('indexIsHidden');
    }
  }
  toggleIndex() {
    if (this.body.classList.contains('indexIsHidden')) {
      this.body.classList.remove('indexIsHidden');
    } else {
      this.body.classList.add('indexIsHidden');
    }
  }
  fetchData() {
    const { edition, fetchProjects } = this.props;
    fetchProjects(edition);
  }
  render() {
    const { lang, isFetching, projects, edition, children, params } = this.props;
    const nested = React.Children.map(children, child =>
      React.cloneElement(child, {
        edition,
      }),
    );
    if (isFetching && !projects.length) {
      return (
        <div className="fold fold--projects fold--main">
          <Loading />
        </div>
      );
    }
    return (
      <div className="fold fold--projects fold--main">
        <div className="fold--main__inner">
          <IndexList
            onClickIndexItem={this.onClickItem}
            lang={lang}
            toggleIndex={this.toggleIndex}
            content={projects}
            title={langMap.projects}
            params={params}
            edition={edition}
          />
          { nested }
        </div>
      </div>
    );
  }
}

Projects.propTypes = {
  lang: PropTypes.string.isRequired,
  children: PropTypes.node,
  fetchProjects: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  projects: PropTypes.arrayOf(PropTypes.object).isRequired,
  edition: PropTypes.shape({
    background: PropTypes.string,
    backgroundTextColor: PropTypes.string,
    id: PropTypes.string,
    year: PropTypes.string,
  }).isRequired,
  params: PropTypes.objectOf(PropTypes.string).isRequired,
};

Projects.defaultProps = {
  children: undefined,
};

const mapStateToProps = (state, { edition }) => ({
  projects: getVisibleProjects(state, edition),
  isFetching: getIsProjectsFetching(state),
  edition,
});

Projects = connect(
  mapStateToProps,
  actions,
)(Projects);

export default Projects;



// WEBPACK FOOTER //
// ./js/containers/Projects.js